import { DiscountCodeType } from './enum/discount-code-type';

export class DiscountCode {
    DiscountId: string;
    Name: string;
    DiscountCodeType: DiscountCodeType;
    AmountOrPercentage: number;
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/models/discount-code.ts